import React from "react";
import "./SalaryTable.css";

const SalaryTable = ({ selectedMonth, departments, onDepartmentClick }) => {
  const formatMonthYear = (date) => {
    const months = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2); // Последние 2 цифры года
    return `${day}.${month}.${year}`;
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "На рассмотрении":
        return "⏳";
      case "Согласован":
        return "✓";
      case "Отклонено":
        return "✗";
      default:
        return "";
    }
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "На рассмотрении":
        return "status-pending";
      case "Согласован":
        return "status-approved";
      case "Отклонено":
        return "status-rejected";
      default:
        return "";
    }
  };

  const getRowClassName = (department) => {
    if (!department.approvers || department.approvers.length === 0) {
      return ""; // Нейтральный - белый
    }

    const statuses = department.approvers.map((a) => a.status);
    const hasRejected = statuses.some((s) => s === "Отклонено");
    const hasPending = statuses.some((s) => s === "На рассмотрении");
    const allApproved = statuses.every((s) => s === "Согласован");

    if (hasRejected) {
      return "salary-table__row--rejected";
    }
    if (allApproved) {
      return "salary-table__row--approved";
    }
    if (hasPending) {
      return "salary-table__row--pending";
    }
    return ""; // Нейтральный - белый
  };

  if (!departments || departments.length === 0) {
    return (
      <div className="salary-table__empty">
        <p>Нет данных для отображения</p>
      </div>
    );
  }

  return (
    <div className="salary-table__container">
      <table className="salary-table">
        <thead>
          <tr>
            <th>Отдел</th>
            <th>Инициатор</th>
            <th>Дата</th>
            <th>Статус</th>
            <th>Дата отправки на согласование</th>
          </tr>
        </thead>
        <tbody>
          {departments.map((department) => (
            <tr
              key={department.id}
              className={`salary-table__row ${getRowClassName(department)}`}
              onClick={() => onDepartmentClick && onDepartmentClick(department)}
              style={{ cursor: onDepartmentClick ? "pointer" : "default" }}
            >
              <td className="salary-table__department">{department.name}</td>
              <td className="salary-table__initiator">
                {department.initiator || "-"}
              </td>
              <td className="salary-table__date">
                <span className="salary-table__date-icon">📅</span>
                {formatMonthYear(selectedMonth)}
              </td>
              <td className="salary-table__status">
                {department.approvers && department.approvers.length > 0 ? (
                  <div className="salary-table__status-list">
                    {department.approvers.map((approver, index) => (
                      <div
                        key={index}
                        className={`salary-table__approver ${getStatusClassName(
                          approver.status,
                        )}`}
                      >
                        <span className="salary-table__approver-role">
                          {approver.role} ({approver.name}):
                        </span>
                        <span
                          className={`salary-table__approver-status ${getStatusClassName(
                            approver.status,
                          )}`}
                        >
                          <span className="salary-table__status-icon">
                            {getStatusIcon(approver.status)}
                          </span>
                          {approver.status}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className="salary-table__no-status">-</span>
                )}
              </td>
              <td className="salary-table__submission-date">
                {department.submissionDate ? (
                  <>
                    <span className="salary-table__date-icon">📅</span>
                    {formatDate(department.submissionDate)}
                  </>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalaryTable;
